import React from 'react';
import { Box, Typography, Grid, List, ListItem, ListItemText } from '@mui/material';
import avidLogo from '../../../../assets/logos/AvidRatings.png';

export const AvidSection = () => {
  const milestones = [
    'At closing',
    'Around 30 days after move-in',
    'At your 1-year homeownership anniversary'
  ];

  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 4 }
      }}
    >
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={8}>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              lineHeight: 1.6,
              color: '#333'
            }}
          >
            We're honored to be part of your homebuilding journey and truly value your feedback
            along the way. That's why we've partnered with Avid Ratings to send you a few short
            surveys throughout your first year of homeownership. These surveys help us celebrate
            what's going well and learn how we can continue to improve the experience for you and
            future homeowners.
          </Typography>

          <Typography variant="body1">
            You'll receive a survey at the following milestones:
          </Typography>

          <List sx={{ pl: 2, py: 0 }}>
            {milestones.map((milestone, index) => (
              <ListItem key={index} sx={{ py: 0, pl: 0 }}>
                <Typography variant="body1" component="span" sx={{ mr: 1 }}>
                  •
                </Typography>
                <ListItemText primary={milestone} />
              </ListItem>
            ))}
          </List>

          <Typography
            variant="body1"
            sx={{
              mt: 3
            }}
          >
            Thank you in advance for taking the time to share your thoughts — your feedback means so
            much to us!
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <img
              src={avidLogo}
              alt="Avid Ratings"
              style={{
                maxWidth: '100%',
                height: 'auto',
                maxHeight: '100px'
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
